export default __webpack_public_path__ + "static/audio-cardio-2-a-b81a07beda393e0ce3d498e908b8f89b.webp";